<!--
 * @Description: 新增商机
 * @Author: mdb
 * @Date: 2022-07-01 15:31:13
 * @LastEditTime: 2023-06-25 14:35:30
 * @LastEditors: cxh
-->
<template>
  <CosLayoutMain>
    <template #content>
      <BusinessForm
        ref="businessFormRef"
        title="新增商机"
        type="add"
        v-model:value="dataForm"
        :saleChanceRefId="saleChanceRefId"
        @update:value="fetch"
      />
    </template>
    <template #footer>
      <cos-footer-button :loading="loading" v-model:value="dataForm" hideOk :disabled="false" :resetValue="initForm">
        <a-button v-permission="'lbu_business_add_btn'" type="primary" :loading="loading" @click="handleSubmit()"
        >保存
        </a-button
        >
        <a-button v-permission="'lbu_business_add_btn'" type="primary" :loading="loading" @click="handleSubmit('again')"
        >保存并新建
        </a-button
        >
      </cos-footer-button>
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit } from '@/api/yuntuSales/chanceManage'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'

const route = useRoute()

const dataForm = ref<LbuBusinessEditParams>({})

// 赋值url参数到dataForm
const saleChanceRefId = ref<boolean>()
if (route.query.saleChanceRefId) {
  dataForm.value.saleChanceRefId = route.query.saleChanceRefId as string
  saleChanceRefId.value = true
}
if (route.query.isFromPotentialCustomer) {
  dataForm.value.isFromPotentialCustomer = true
}
const fetch = (val: any) => {
  dataForm.value = val
}

const businessFormRef = ref()

const loading = ref(false)
const handleSubmit = (type?: string) => {
  businessFormRef.value?.validate().then(() => {
    loading.value = true
    businessCreateOrEdit(dataForm.value)
      .then(() => {
        message.success('新增成功')
        const {
          saleChanceRefId,
          status,
          saleChanceType,
          competitors,
          competitionSituation,
          customerSituation,
          requiredSupport,
          remark
        } = dataForm.value
        businessFormRef.value?.resetFields()
        if (type === 'again') {
          dataForm.value = {
            saleChanceRefId,
            status,
            saleChanceType,
            competitors,
            competitionSituation,
            customerSituation,
            requiredSupport,
            remark
          }
        } else {
          goBack()
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuBusinessAdd' }
</script>

<style scoped></style>
